import { render, staticRenderFns } from "./CardWithSymbols.vue?vue&type=template&id=11d3f037&scoped=true"
import script from "./CardWithSymbols.vue?vue&type=script&lang=js"
export * from "./CardWithSymbols.vue?vue&type=script&lang=js"
import style0 from "./CardWithSymbols.vue?vue&type=style&index=0&id=11d3f037&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3f037",
  null
  
)

export default component.exports